import React, { useState } from 'react';
import { CheckIcon, MinusIcon, PlusIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
import { faqItems } from '../../data/content';
export function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);
  return <section className="w-full bg-cream px-4 py-12 sm:px-6 sm:py-20" data-id="element-191" data-mp="123obmurowex2">
      <div className="mx-auto max-w-2xl" data-id="element-192" data-mp="1psh94vnymuts">
        <div className="text-center" data-id="element-193" data-mp="1psprh32uqscd">
          <SectionLabel data-id="element-194" data-mp="1uraqiz6db5z8">Domande frequenti</SectionLabel>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-tight text-navy-deep sm:text-4xl" data-id="element-195" data-mp="1uqr8ligpwhl7">
            Tutto quello che vuoi sapere
          </h2>
        </div>

        <ul className="mt-8 flex flex-col gap-3 sm:mt-12" data-id="element-196" data-mp="1l0ftr0vhwnzj">
          {faqItems.map(item => {
          const isOpen = openId === item.id;
          return <li key={item.id} className="overflow-hidden rounded-2xl border border-navy-deep/10 bg-white" data-id="element-197" data-mp="2dhiega1hxpuu">
                <button type="button" onClick={() => setOpenId(isOpen ? null : item.id)} aria-expanded={isOpen} aria-controls={`${item.id}-panel`} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-cream sm:px-6" data-id="element-198" data-mp="2oqib7qwxrk7w">
                  <span className="text-[14.5px] font-extrabold leading-snug text-navy-deep sm:text-base" data-id="element-199" data-mp="37f5hgcqumfn2">
                    {item.question}
                  </span>
                  {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-kidney-dark" aria-hidden="true" data-id="element-200" data-mp="3he4q3vbm6ba2" /> : <PlusIcon className="h-4 w-4 shrink-0 text-kidney-dark" aria-hidden="true" data-id="element-201" data-mp="1n1oc28cktsun" />}
                </button>

                {isOpen ? <div id={`${item.id}-panel`} className="border-t border-navy-deep/10 px-4 py-4 sm:px-6" data-id="element-202" data-mp="27sac62ma6qew">
                    <div className="flex flex-col gap-2.5" data-id="element-203" data-mp="2gp15w8dd1t6b">
                      {item.answer.map(paragraph => <p key={paragraph} className="text-[14px] leading-relaxed text-navy/75" data-id="element-204" data-mp="2lnm6i8wiyeva">
                          {paragraph}
                        </p>)}
                    </div>
                    {item.items ? <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-205" data-mp="34g6tj9pjlpr6">
                        {item.items.map(entry => <li key={entry} className="flex gap-2" data-id="element-206" data-mp="39g2rosbk6myt">
                            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-kidney" aria-hidden="true" data-id="element-207" data-mp="3eee0r0u14tfz" />
                            <span className="text-[13.5px] leading-snug text-navy/85" data-id="element-208" data-mp="xrxv94ap4rll">
                              {entry}
                            </span>
                          </li>)}
                      </ul> : null}
                  </div> : null}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-9 max-w-md sm:mt-12" data-id="element-209" data-mp="1lgqt56avp9iu">
          <CtaButton label="Ho tutto chiaro — voglio accedere" sub="Download immediato • Pagamento unico • Garanzia di 7 giorni" data-id="element-210" data-mp="1gi5s54nsyltc" />
        </div>
      </div>
    </section>;
}